<div id="cdk-shortcuts" #shortcuts>

  @if (!mobileShortcutsPanelActive) {
    <div class="shortcuts-mobile-toggle flex flex-row justify-start items-center content-center md:hidden">
      <button mat-icon-button (click)="showMobileShortcutsPanel()">
        <mat-icon class="text-amber-600">star</mat-icon>
      </button>
    </div>
  }

  <div class="shortcuts flex flex-row lt-md:hidden">

    <div class="flex flex-row grow-0 shrink basis-auto justify-between items-center content-center">

      <div class="flex flex-row justify-start items-center content-center">

        @for (shortcutItem of shortcutItems; track shortcutItem) {
          <div class="w-40 h-40 p-1 flex flex-row justify-center items-center content-center"
            >
            <a mat-icon-button matTooltip="{{shortcutItem.title}}" [routerLink]="shortcutItem.url">
              @if (shortcutItem.icon) {
                <mat-icon class="text-secondary">{{shortcutItem.icon}}</mat-icon>
              }
              @if (!shortcutItem.icon) {
                <span class="h2 text-secondary text-bold">
                  {{shortcutItem.title.substr(0, 1).toUpperCase()}}
                </span>
              }
            </a>
          </div>
        }

        <button mat-icon-button [matMenuTriggerFor]="addMenu" matTooltip="Click to add/remove shortcut"
          (menuOpened)="onMenuOpen()">
          <mat-icon class="text-amber-600">star</mat-icon>
        </button>

      </div>

      <div class="shortcuts-mobile-close flex flex-row justify-start items-center content-center sm:hidden">
        <button mat-icon-button (click)="hideMobileShortcutsPanel()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

    </div>

    <mat-menu #addMenu="matMenu" class="w-240">

      <mat-form-field class="px-4 w-100-p" (click)="$event.stopPropagation()" floatLabel="never">
        <input #searchInput matInput placeholder="Search for an app or a page" (input)="search($event)">
      </mat-form-field>

      <mat-divider></mat-divider>

      @if (!searching) {
        <mat-nav-list style="max-height: 312px; overflow: auto" cdkScrollbar  [cdkScrollbarOptions]="{suppressScrollX: false, suppressScrollY: false, wheelPropagation: false, updateOnRouteChange: true}">
          @for (shortcutItem of shortcutItems; track shortcutItem) {
            <mat-list-item
              (click)="toggleShortcut($event, shortcutItem)">
              <div class="w-100-p flex flex-row justify-start items-center content-center">
                @if (shortcutItem.icon) {
                  <mat-icon mat-list-icon class="mr-2 text-secondary">
                    {{shortcutItem.icon}}
                  </mat-icon>
                }
                @if (!shortcutItem.icon) {
                  <span class="h2 w-32 h-32 p-1 mr-2 text-secondary text-bold flex flex-row justify-center items-center content-center">
                    {{shortcutItem.title.substr(0, 1).toUpperCase()}}
                  </span>
                }
                <p class="flex" matLine>{{shortcutItem.title}}</p>
                <mat-icon class="ml-2 text-amber">star</mat-icon>
              </div>
            </mat-list-item>
          }
          @if (shortcutItems.length === 0) {
            <mat-list-item>
              <p>
                <small>Sem atalhos ainda</small>
              </p>
            </mat-list-item>
          }
        </mat-nav-list>
      }

      @if (searching) {
        <mat-nav-list style="max-height: 312px; overflow: auto" cdkScrollbar  [cdkScrollbarOptions]="{suppressScrollX: false, suppressScrollY: false, wheelPropagation: false, updateOnRouteChange: true}">
          @for (navigationItem of filteredNavigationItems; track navigationItem) {
            <mat-list-item
              (click)="toggleShortcut($event, navigationItem)">
              <div class="w-100-p flex flex-row justify-start items-center content-center">
                @if (navigationItem.icon) {
                  <mat-icon mat-list-icon class="mr-2 text-secondary">
                    {{navigationItem.icon}}
                  </mat-icon>
                }
                @if (!navigationItem.icon) {
                  <span class="h2 w-32 h-32 p-4 mr-2 text-secondary text-bold flex flex-row justify-center items-center content-center">
                    {{navigationItem.title.substr(0, 1).toUpperCase()}}
                  </span>
                }
                <p class="flex" matLine>{{navigationItem.title}}</p>
                @if (isInShortcuts(navigationItem)) {
                  <mat-icon class="ml-2 text-amber">star</mat-icon>
                }
              </div>
            </mat-list-item>
          }
        </mat-nav-list>
      }

    </mat-menu>

  </div>

</div>
